// Cross-component bridge to show a small "server error" toast. Mirrors
// authRequired.js's window-event bridge — producers (http_service's
// 404/5xx hooks) aren't inside the toast's React tree, so they notify it
// via a window CustomEvent instead of prop drilling.

export const SERVER_ERROR_TOAST_EVENT = "aidea:server-error";

// Cooldown guard: a failing poller can hit this repeatedly, so throttle to
// one dispatch per 10s instead of stacking toasts (unlike authRequired's
// once-forever latch, this can re-fire after the cooldown).
const COOLDOWN_MS = 10000;
let lastShown = 0;

export function triggerServerErrorToast(status) {
  if (typeof window === "undefined") return;
  const now = Date.now();
  if (now - lastShown < COOLDOWN_MS) return;
  lastShown = now;
  try {
    window.dispatchEvent(new CustomEvent(SERVER_ERROR_TOAST_EVENT, { detail: { status } }));
  } catch (err) {
    console.warn("[serverErrorToast] dispatch failed", err);
  }
}
